import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';

const KlubDashboardStatCard = ({
  to,
  color,
  icon,
  label,
  value,
  hint,
  fill,
  active = false,
  actionFirst = false,
  secondaryValue = null,
}) => {
  const title = actionFirst ? hint : label;
  const subtitle = actionFirst ? label : hint;
  return (
    <Link
      to={to}
      className={`klub-dashboard__stat-card${fill ? ` klub-dashboard__stat-card--fill-${fill}` : ''}${active ? ' is-active' : ''}`}
    >
      <div className={`klub-dashboard__stat-icon ${fill ? 'klub-dashboard__stat-icon--on-fill' : `bg-${color}-focus`}`}>
        <Icon icon={icon} className={fill ? '' : `text-${color}-main`} />
      </div>
      <div className="klub-dashboard__stat-body">
        <div className={`klub-dashboard__stat-label${actionFirst ? ' is-strong' : ''}`}>{title}</div>
        <div className="klub-dashboard__stat-metrics">
          <div className="klub-dashboard__stat-value">
            {value ?? 0}
            {secondaryValue != null ? <small> ent.</small> : null}
          </div>
          {secondaryValue != null ? (
            <div className="klub-dashboard__stat-value klub-dashboard__stat-value--side">
              {secondaryValue}
              <small> sal.</small>
            </div>
          ) : null}
        </div>
        {subtitle ? <div className="klub-dashboard__stat-hint">{subtitle}</div> : null}
      </div>
    </Link>
  );
};

export default KlubDashboardStatCard;
